import Checkbox from './checkbox';
import Group from './checkbox-group';

Checkbox.Group = Group;

export default Checkbox;